<template>
  <div style="z-index: 2" id="foliomap" ref="foliomap" :style="{ height: height + 'px', minHeight: '400px' }" />
</template>

<script>
import 'leaflet/dist/leaflet.css'
import { FolioLeaf } from '@/my-leaf/charts/folio-leaf'
import { mapStores } from 'pinia'
import { useCatalogsStore } from '@/stores/catalogs'
import { useDeviceStore } from '@/stores/device'

export default {
  name: 'FolioMap',
  props: ['height'],
  data() {
    return {
      foliomap: new FolioLeaf(),
    }
  },
  methods: {
    showFolioCell(cellName) {
      this.foliomap.highlightCell(cellName)
    },
    async init_map() {
      try {
        // Ждем асинхронную инициализацию карты
        await this.foliomap.init(this.$refs.foliomap);

        const allCharts = this.catalogsStore.getItems;
        const purchasedList = this.deviceStore.orderedData.primar.enc;
        const purchasedIds = purchasedList.map(item => item.name);

        // Фильтрация только приобретённых ячеек
        const purchasedCharts = allCharts.filter(chart => {
          return purchasedIds.includes(chart.id);
        });

        this.foliomap.showRoute();
        this.foliomap.drawAllCells(purchasedCharts);
        
        return Promise.resolve();
      } catch (error) {
        console.error('FolioMap: error initializing map:', error);
        return Promise.reject(error);
      }
    },
  },

  computed: {
    ...mapStores(useDeviceStore, useCatalogsStore),
  },

  beforeDestroy() {
    // Очищаем Leaflet карту и освобождаем ресурсы
    if (this.foliomap) {
      try {
        // Use the destroy method for complete cleanup
        this.foliomap.destroy()
        this.foliomap = null

        console.log('FolioMap: map and resources cleaned up')
      } catch (error) {
        console.warn('FolioMap: error cleaning up map', error)
      }
    }
  },
}
</script>

<style>
#foliomap {
  border: solid 1px dimgray;
}

.leaflet-interactive:hover {
  stroke: #ffa011;
  stroke-width: 4;
}
</style>
